import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has('X-Skip-Loader')) {
    const skipReq = req.clone({
      headers: req.headers.delete('X-Skip-Loader')
    });
    return next(skipReq);
  }

  const loader = inject(LoaderService);
  let hidden = false;
  let fallbackTimer: number;

  const hideOnce = () => {
    if (hidden) return;
    hidden = true;
    window.clearTimeout(fallbackTimer);
    loader.hide();
  };

  fallbackTimer = window.setTimeout(() => hideOnce(), 20000);

  loader.show();

  return next(req).pipe(
    tap((event) => {
      // Some APIs can emit a successful response before the stream fully completes.
      // Hide immediately on first HttpResponse to avoid a stuck global loader.
      if (event instanceof HttpResponse) {
        hideOnce();
      }
    }),
    finalize(() => hideOnce())
  );
};
